module.exports = __webpack_public_path__ + "public/images/prizes/prize-4.8d1b31bfc333eb48c9cd05aadc45dd53.jpeg";